import { apiCall } from "../utility/apiCall";

export const getPastUploads = async (payload, page, limit) => {
  return await apiCall(`api/pastUploads?id=${payload}&page=${page}&limit=${limit}`, "GET", payload);
};

export const getPaymentHistory = async payload => {
  return await apiCall("api/paymentHistory", "POST", payload);
};

export const loadProfile = async payload => {
  return await apiCall("api/settings/getProfileDetails", "POST", payload);
};

export const updateProfile = async payload => {
  return await apiCall("api/settings/updateProfileDetails", "POST", payload);
};

export const updatePassword = async payload => {
  return await apiCall("api/settings/updatePassword", "POST", payload);
};

export const getRecurringPayment = async function() {
  return await apiCall("api/recurring-payment", "GET");
};



// WEBPACK FOOTER //
// ./src/services/settings.js